<mat-toolbar style="display: flex; justify-content: center">
  <img [src]="node.image" alt="Icono de Persona" style="width: 50px; height: 50px; border-radius: 50px" />
  <h1 class="text-center">{{ node.label }}</h1>
  <button mat-icon-button (click)="dismiss()">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>

<mat-card>
  <mat-card-content>
    <div>
      <mat-icon>cuenta</mat-icon>
      <div>
        <div class="container">
          <div class="row" *ngIf="isCuenta">
            <p *ngIf="node.numero_cuenta" class="col-6">
              <strong>Número de cuenta:</strong> {{ node.numero_cuenta }}
            </p>
            <p *ngIf="node.tipo_cuenta" class="col-6">
              <strong>Tipo de cuenta:</strong> {{ node.tipo_cuenta }}
            </p>
            <p *ngIf="node.numero_pago_movil" class="col-6">
              <strong>Número de pago móvil:</strong>
              {{ node.numero_pago_movil }}
            </p>
            <p *ngIf="node.banco" class="col-6">
              <strong>Banco:</strong> {{ node.banco.nombre }}
            </p>
            <p *ngIf="node.detalles_cuenta" class="col-6">
              <strong>Detalles de cuenta:</strong> {{ node.detalles_cuenta }}
            </p>
            <ng-container *ngIf="cuentaModel && cuentaModel.identidad">
              <p *ngIf="cuentaModel.identidad.tipo" class="col-6">
                <strong>Tipo Documento:</strong>
                {{ cuentaModel.identidad.tipo }}
              </p>
              <p *ngIf="cuentaModel.identidad.numero" class="col-6">
                <strong>Número Documento:</strong>
                {{ cuentaModel.identidad.numero }}
              </p>
              <p *ngIf="cuentaModel.identidad.nombre" class="col-6">
                <strong>Nombre:</strong> {{ cuentaModel.identidad.nombre }}
              </p>
              <p *ngIf="cuentaModel.identidad.apellido" class="col-6">
                <strong>Apellido:</strong>
                {{ cuentaModel.identidad.apellido }}
              </p>
              <p *ngIf="cuentaModel.identidad.genero" class="col-6">
                <strong>Género:</strong> {{ cuentaModel.identidad.genero }}
              </p>
              <p *ngIf="cuentaModel.identidad.fecha_nacimiento" class="col-6">
                <strong>Fecha de Nacimiento:</strong>
                {{ cuentaModel.identidad.fecha_nacimiento }}
              </p>
              <p *ngIf="cuentaModel.identidad.nacionalidad" class="col-6">
                <strong>Nacionalidad:</strong>
                {{ cuentaModel.identidad.nacionalidad }}
              </p>
              <p *ngIf="cuentaModel.identidad.direccion" class="col-6">
                <strong>Dirección:</strong>
                {{ cuentaModel.identidad.direccion }}
              </p>
              <p *ngIf="cuentaModel.identidad.telefono" class="col-6">
                <strong>Teléfono:</strong>
                {{ cuentaModel.identidad.telefono }}
              </p>
              <p *ngIf="cuentaModel.identidad.correo" class="col-6">
                <strong>Correo:</strong> {{ cuentaModel.identidad.correo }}
              </p>
            </ng-container>
          </div>
          <div *ngIf="!isCuenta" class="row">
            <p *ngIf="node.tipo" class="col-6">
              <strong>Tipo Documento:</strong> {{ node.tipo }}
            </p>
            <p *ngIf="node.numero" class="col-6">
              <strong>Número Documento:</strong> {{ node.numero }}
            </p>
            <p *ngIf="node.nombre" class="col-6">
              <strong>Nombre:</strong> {{ node.nombre }}
            </p>
            <p *ngIf="node.apellido" class="col-6">
              <strong>Apellido:</strong> {{ node.apellido }}
            </p>
            <p *ngIf="node.genero" class="col-6">
              <strong>Género:</strong> {{ node.genero }}
            </p>
            <p *ngIf="node.fecha_nacimiento" class="col-6">
              <strong>Fecha de Nacimiento:</strong>
              {{ node.fecha_nacimiento }}
            </p>
            <p *ngIf="node.nacionalidad" class="col-6">
              <strong>Nacionalidad:</strong> {{ node.nacionalidad }}
            </p>
            <p *ngIf="node.direccion" class="col-6">
              <strong>Dirección:</strong> {{ node.direccion }}
            </p>
            <p *ngIf="node.telefono" class="col-6">
              <strong>Teléfono:</strong> {{ node.telefono }}
            </p>
            <p *ngIf="node.correo" class="col-6">
              <strong>Correo:</strong> {{ node.correo }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <mat-divider></mat-divider>
    <mat-divider *ngIf="trecibidas.length"></mat-divider>
    <div *ngIf="trecibidas.length">
      <br />
      <h3>Transacciones recibidas</h3>
      <div class="row" *ngFor="let transferencia of trecibidas">
        <mat-form-field appearance="outline" class="col-3">
          <mat-label>Cuenta</mat-label>
          <input matInput [(ngModel)]="transferencia.cuenta" disabled>
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-3">
          <mat-label>Referencia</mat-label>
          <input matInput [(ngModel)]="transferencia.referencia" disabled />
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-3">
          <mat-label>Fecha</mat-label>
          <input matInput [value]="transferencia.fecha | date:'dd/MM/yy HH:mm:ss'" disabled />
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-3" readonly>
          <mat-label>Monto</mat-label>
          <input matInput [value]="transferencia.monto_recibido" currencyMask type="text" disabled />
        </mat-form-field>
      </div>
    </div>
    <mat-divider *ngIf="tenviadas.length != 0"></mat-divider>
    <div *ngIf="tenviadas.length != 0">
      <br />
      <h1>Transacciones enviadas</h1>
      <div class="row" *ngFor="let transferencia of tenviadas">
        <mat-form-field appearance="outline" class="col-3">
          <mat-label>Cuenta</mat-label>
          <input matInput [(ngModel)]="transferencia.cuenta" disabled>
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-3">
          <mat-label>Referencia</mat-label>
          <input matInput [(ngModel)]="transferencia.referencia" disabled />
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-3">
          <mat-label>Fecha</mat-label>
          <input matInput [value]="transferencia.fecha | date:'dd/MM/yy HH:mm:ss'" disabled />
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-3" *ngIf="!cuenta_afectada">
          <mat-label>Monto</mat-label>
          <input matInput [value]="transferencia.monto_recibido" currencyMask type="text" disabled />
        </mat-form-field>
      </div>
    </div>
    <div class="button-container">
      <button mat-raised-button style="color: #016cac" (click)="dismiss()">
        Cerrar
      </button>
    </div>
  </mat-card-content>
</mat-card>